import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  cardWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(0, 1),
    width: '100%',
  },

  cardForm: {
    margin: theme.spacing(0, 0, 1)
  },

  cardContent: {
    boxShadow: 'none'
  },

  cardText: {
    color: theme.palette.grey.dark,
    fontSize: '12px',
    margin: theme.spacing(0, 0, .5),
    fontWeight: 600
  },

  inputBase: {
    padding: 0,
    '& .MuiInputBase-input': {
      padding: 0,
      height: '100%',
    }
  }

}));

export default useStyles;
